import ProfilePage from "./view/ProfilePage.vue";

const routes = [
  {
    path: '/profile',
    name: 'profile',
    component: ProfilePage,
    meta: {
      title: 'Profile',
      requiresAuth: true,
    }
  }
];

export default routes;
